import { render } from "./BreadcrumbView.vue?vue&type=template&id=5ff37ebe&scoped=true"
import script from "./BreadcrumbView.vue?vue&type=script&lang=js"
export * from "./BreadcrumbView.vue?vue&type=script&lang=js"

import "./BreadcrumbView.vue?vue&type=style&index=0&id=5ff37ebe&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff37ebe"]])

export default __exports__